import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useProjectContext } from 'context/project-context'
import { useFetchLegends } from 'services/legend'
import { Legend } from './components/Legend'
import { Disclosure } from 'components/Disclosure'
import styles from './Legends.module.scss'

export const Legends: FC = () => {
  const { t } = useTranslation()
  const [{ activeLayers, hiddenLayers }] = useProjectContext()
  const layerIds = activeLayers.filter((layerId) => !hiddenLayers.includes(layerId))
  const { legends } = useFetchLegends(layerIds)

  if (legends.length === 0) return null

  return (
    <Disclosure title={t('legends.title')} defaultOpen className={styles.legends}>
      <div className={styles.content}>
        {legends.map((legend) => (
          <Legend key={legend.name} legend={legend} />
        ))}
      </div>
    </Disclosure>
  )
}

Legends.displayName = 'Legends'
